var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-settings-content-template',[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('w-event-alarm-rule-tree',{class:_vm.$style.side,on:{"select-rule":_vm.selectRule}}),_vm._v(" "),_c('w-event-alarm-rule-table',{class:_vm.$style.main,attrs:{"selected-rule":_vm.selectedRule,"has-auth":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-247d31d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/operation/BasicInfoSettings/EventAlarmRuleSettings/index.vue
// module id = null
// module chunks = 